import { DomainIdentifier } from "./domainService";

export function updateZipSpan(container: HTMLElement, modal: HTMLElement, spanSelector: string) {
    const zipCodeSpan = container?.querySelector(spanSelector);
    const zipInput = modal?.querySelector('#dynamic-local-search-modal');
    if (zipCodeSpan && zipInput) {
        zipCodeSpan.textContent = (zipInput as HTMLInputElement).value.trim();
    }
}

export function updateServiceHeadingUtil({
    modal,
    happyText,
    notFoundText,
}: {
    modal: HTMLElement,
    happyText: HTMLElement | null,
    notFoundText: HTMLElement | null,
}) {
    const headingText = modal.getAttribute('data-service-heading') ?? 'Electrical Services';
    const domain = DomainIdentifier();

    if (happyText && !happyText.dataset?.template) happyText.dataset.template = happyText.innerHTML;
    if (notFoundText && !notFoundText.dataset?.template) notFoundText.dataset.template = notFoundText.innerHTML;

    if (happyText?.dataset?.template) {
        let text = happyText.dataset.template.replace(
            /We found (.*?) Services/i,
            `We found ${headingText}`
        );
        if (domain === 'ca') text = text.replace(/ZIP code/gi, 'Postal code');
        happyText.innerHTML = text;
        updateZipSpan(happyText, modal, 'span.text-primary-500');
    }
    if (notFoundText?.dataset?.template) {
        let text = notFoundText.dataset.template.replace(
            /We are sorry (.*?) Services is not offered/i,
            `We are sorry ${headingText} is not offered`
        );
        if (domain === 'ca') text = text.replace(/ZIP code/gi, 'Postal code');
        notFoundText.innerHTML = text;
        updateZipSpan(notFoundText, modal, 'span');
    }
}